import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

/**
 * Porta de entrada das rotas internas.
 *
 * `roles` — papéis autorizados (super_admin passa sempre).
 * `permitirMonitor` — libera TAMBÉM o Monitor ATIVO. O Monitor continua sendo
 *   `athlete` no banco (o vínculo com a equipe é que dá o acesso), então sem
 *   esta flag a checagem por papel o barraria. É opt-in e explícito: só as
 *   rotas que declaram a flag aceitam Monitor — nada mais foi afrouxado.
 */
export function ProtectedRoute({ children, roles = [], permitirMonitor = false }) {
  const { user, loading, eMonitor } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
        <Loader2 className="w-8 h-8 text-[#D4AF37] animate-spin" aria-hidden="true" /><span role="status" aria-live="polite" className="ml-2 text-sm text-[#A1A1AA]">Carregando...</span>
      </div>
    );
  }

  if (!user) {
    /* ETAPA 11 — a página pública é a inicial e traz o login embutido, então
       quem não tem sessão vai para lá (e não mais para /login, que saiu da
       navegação). O endereço `/login` continua existindo, para uso futuro. */
    return <Navigate to="/" replace />;
  }

  const monitorLiberado = permitirMonitor && !!eMonitor;
  if (roles.length > 0 && !roles.includes(user.role) && user.role !== 'super_admin' && !monitorLiberado) {
    // Athletes redirect to championships since they don't have dashboard
    const fallback = user.role === 'athlete' ? '/championships' : '/dashboard';
    return <Navigate to={fallback} replace />;
  }

  return children;
}
